import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = "查看更多" }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-3">
          <span className="w-1.5 h-6 rounded-full bg-accent-500" />
          {title}
        </h2>
        {subtitle && <p className="text-sm text-foreground-500 mt-2 ml-4">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}